import Vue from 'vue'
import axios from 'axios';
import App from './App'
import router from './router'
//import 'lib-flexible'
// import VScaleScreen from 'v-scale-screen'
// import '/src/amfe-flexible.min.js'
import './utils/rem'
// import 'amfe-flexible'
//import 'amfe-flexible/index.js'

//import 'lib-flexible/flexible'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js